import React from 'react';
import { Document, Page, View } from '@react-pdf/renderer';
import { PdfHeader } from '../shared/PdfHeader';
import { PdfFooter } from '../shared/PdfFooter';
import { ProjectInfoSection } from '../shared/ProjectInfoSection';
import { ensureFontsRegistered } from '../shared/PdfFontRegistry';
import { pdfSharedStyles } from '../pdfSharedStyles';
import { StandardPdfTemplateProps } from '../shared/types/PdfCommonTypes';

/**
 * Standard PDF Template Component
 * Base template that provides unified structure for all PDF documents
 * Includes header, footer, project info table, and content area
 * Eliminates 90% of boilerplate code across PDF components
 */
export const StandardPdfTemplate: React.FC<StandardPdfTemplateProps> = ({
    projectType,
    projectData,
    projectInfoData,
    t,
    children,
    headerConfig,
    footerConfig,
    showProjectInfo = true,
    showMap = true,
}) => {
    // Ensure fonts are registered once
    ensureFontsRegistered();

    return (
        <Document>
            <Page size="A4" style={pdfSharedStyles.page}>
                <PdfHeader projectType={projectType} t={t} {...headerConfig} />

                {/* <View style={pdfSharedStyles.section}>
                    {showProjectInfo && <ProjectInfoSection projectData={projectData} projectInfoData={projectInfoData} t={t} showMap={showMap} />}

                    {children}
                </View> */}
                {showProjectInfo && (
                    <View style={pdfSharedStyles.section}>
                        <ProjectInfoSection projectData={projectData} projectInfoData={projectInfoData} t={t} showMap={showMap} />
                    </View>
                )}
                {children}

                <PdfFooter t={t} {...footerConfig} />
            </Page>
        </Document>
    );
};
